import { PaletteMode , createTheme } from "@mui/material";
import ThemeOption from "./theme";


const themePalette = (mode:PaletteMode ) => {

    const paletteColor = ThemeOption(mode);

    return createTheme({
        palette:{
            mode ,
            common : {
                black:"#000000" ,
                white:"#FFFFFF"
            } ,
            ...paletteColor ,
        }
    });
};

export default themePalette;
